import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-truck",
  "use": "icon-truck-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-truck\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M8 16a2 2 0 1 1 .001 3.999A2 2 0 0 1 8 16zm11 0a2 2 0 1 1 .001 3.999A2 2 0 0 1 19 16zm-.61-8c1.726 0 3.125 1.4 3.125 3.125v1.166c0 .441.277.834.692.982l.101.036c.415.148.692.54.692.98V18h-1a3 3 0 1 0-6 0h-1V8h3.39zM14 6v12h-3a3 3 0 1 0-6 0H2V6h12z\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol